<template>
    <div>
        <div class="darkbg"></div>
        <div class="alertdialog ">
            <div class="block flex_mobile"
                style="display: flex; justify-content: flex-end; align-items: center; position:absolute;right:1rem;top:1rem;">
                <img src="/images/icon_close.png" class="closer_img" style="cursor:pointer" @click="close()">
            </div>
            <div class="block main_block" style="">

                <div class="r" style="padding:0;">

                    <div class="left_c " style="flex-direction:column;">

                        <div class='l_line1'>Make a Difference with Every Trip You Book!</div>
                        <!--    <div class='l_line2'>Lorem ipsum dolor sit amet</div> -->

                        <div class='l_line3'>
                            Every trip you book with TripToGo makes a difference. We proudly donate a portion of each
                            booking to meaningful causes close to our hearts, including children’s hospitals, clean
                            water initiatives, and reforestation projects. Together, let’s explore the world while
                            making a positive impact, one journey at a time.
                        </div>

                    </div>
                    <div class="right_c" style="flex-direction:column;justify-content: flex-start;">
                        <div class="block flex_pc" style="display:flex;align-items: flex-end;margin-bottom:0;">

                            <img src="/images/icon_close.png" class='closer_img' @click="close()">

                        </div>


                        <!-- <div class="block right_block">
                            <div class="r">
                                <img src="/images/footer/logo1.png" />
                            </div>
                            <div class="r ">
                                <span class="txt1 childupdowncenter">
                                    <a style="text-decoration: underline;" target="_blank"
                                        href="https://secure.childrenshospital.org/site/Donation2;jsessionid=00000000.app20059b?idb=1460053259&df_id=5969&mfc_pref=T&5969.donation=form1&NONCE_TOKEN=EE3286EEB1CBF58241E22E39FC54F5C5&s_src=EOY25HB000000&utm_campaign=EOY&utm_source=AG&5969_donation=form1&utm_content=HB0&utm_id=EOY25HB000000&utm_medium=WebExternal">Boston
                                        Children’s Hospital
                                        <img src="/images/footer/money.svg" style="" />
                                    </a>
                                </span>
                                <span class="txt2 childupdowncenter"> <img src="/images/footer/arrow1.svg" style="" />
                                    US$5/ booking</span>

                            </div>
                        </div> -->
                        <div class="block childcenter " style="height:100%;padding:0;margin:0;">

                        <div class="block right_block">
                            <div class="r">
                                <img src="/images/footer/donate_1.png" style="" class='logo1'/>
                            </div>
                            <div class="r ">
                                <span class="txt1 childupdowncenter title1">
                                    <a style="text-decoration: underline;" target="_blank"
                                        href="https://secure.childrenshospital.org/site/Donation2;jsessionid=00000000.app20059b?idb=1460053259&df_id=5969&mfc_pref=T&5969.donation=form1&NONCE_TOKEN=EE3286EEB1CBF58241E22E39FC54F5C5&s_src=EOY25HB000000&utm_campaign=EOY&utm_source=AG&5969_donation=form1&utm_content=HB0&utm_id=EOY25HB000000&utm_medium=WebExternal">Boston
                                        Children’s Hospital
                                        <img src="/images/footer/money.svg" style="" />
                                    </a>
                                </span>
                                <span class="txt2 childupdowncenter"> <img src="/images/footer/arrow1.svg" style="" />
                                    US$5/ booking</span>

                            </div>
                        </div>
                            <div class="block right_block">
                                <div class="r">
                                    <img src="/images/footer/logo2.png" />
                                </div>
                                <div class="r ">
                                    <span class="txt1 childupdowncenter">
                                        <a style="text-decoration: underline;" target="_blank"
                                            href="https://www.sickkidsfoundation.com/pages/bm/ryanreynolds?appeal=25OTA-RR-DG-003">SickKids
                                            Foundation
                                            <img src="/images/footer/money.svg" style="" />
                                        </a>

                                    </span>
                                    <span class="txt2 childupdowncenter"> <img src="/images/footer/arrow1.svg"
                                            style="" />
                                        US$5/ booking</span>

                                </div>
                            </div>
                            <div class="block right_block">
                            <div class="r">
                                <img src="/images/footer/logo3.png" class="logo3" />
                            </div>
                            <div class="r ">
                                <span class="txt1 childupdowncenter">
                                    <a style="text-decoration: underline;" target="_blank"
                                        href="https://www.charitywater.org/">charity: water <img
                                            src="/images/footer/money.svg" style="" /></a>

                                </span>
                                <span class="txt2 childupdowncenter"> <img src="/images/footer/arrow1.svg" style="" />
                                    US$2/ booking</span>

                            </div>
                        </div>
                            <div class="block right_block">
                                <div class="r">
                                    <img src="/images/footer/do4.png" class="logo3" />
                                </div>
                                <div class="r ">
                                    <span class="txt1 childupdowncenter">
                                        <a style="text-decoration: underline;" target="_blank"
                                            href="https://www.arborday.org/">Arbor Day Foundation <img
                                                src="/images/footer/money.svg" style="" /></a>

                                    </span>
                                    <span class="txt2 childupdowncenter"> <img src="/images/footer/arrow1.svg"
                                            style="" />
                                        US$2/ booking</span>

                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>

        </div>
        <!--   <div class="block alertdialog">
           



        </div> -->
    </div>
    <!-- -->
</template>
<script>
import '@/assets/main.css'
import { localDriver } from '@/utils/localDriver'

export default {
    emits: ['closeWin'],
    components: {},
    props: {

    },
    data() {
        return
        {
        }
    },
    created() { },
    methods: {
        async close(t) {
            await localDriver.setItem('clicked_donate', "Y")
            this.$emit('closeWin');
        },

    }
}
</script>



<style lang="scss" scoped>
.flex_mobile {
    display: none;
}

.flex_pc {
    display: flex;
}

.alertdialog {
    text-align: center;
    color: #333;
    width: 95rem;
    top: 50%;
    left: 50%;
    padding: 0rem;
    padding-top: 0rem;

    border-radius: 10px;
    transform: translate(-50%, -50%);
}

.alertdialog .block .left_c {
    background: #FFF3E0;
    padding: 5rem;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;


}

:deep(.logo1)
{
    height:4.5rem!important;width:auto!important;
}
.l_line1 {
    margin-top: 6rem;
    margin-left: 2rem;
    font-family: Merriweather;
    text-align: left;
    font-weight: 400;
    font-size: 3rem;
    line-height: 3.2rem;
    color: #333333;
}

.l_line2 {
    margin-top: 2.5rem;
    margin-left: 2rem;
    font-family: Merriweather;
    text-align: left;

    font-size: 2.2rem;

    color: #333333;
}

.l_line3 {
    margin-top: 2.5rem;
    margin-left: 2rem;

    text-align: left;

    font-size: 1.5rem;

    color: #333333;
    margin-bottom: 4.5rem;
    line-height: 2.5rem;

}


.right_block {
    width: 80%;
    border: 1px solid #cccccc;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
    margin: 1rem 5rem;
    padding: 1.5rem 1.5rem;
 

}

.right_block .r {
    margin: 0;
    padding: 0;
}

.right_block .r:first-of-type {
    margin-bottom: 1rem;
}

.right_block .txt1 {
    color: #666666;
    font-family: Merriweather;
    font-size: 1.2rem;
    margin-right: 1rem;
    width: 57%;
    cursor: pointer;
}

.right_block .txt2 {
    color: #000;
    font-family: Merriweather;
    //font-size: 1.3rem;
    width: 43%;
}

.right_block img {
    height: 3rem;
    width: auto;
    object-fit: cover;
}

.logo3 {
    height: 2.7rem !important;
    width: auto;
    object-fit: cover;
}

.right_block .txt1 img {
    width: 1.5rem;
    height: 1.5rem;
}


.right_block .txt2 img {
    width: 1.5rem;
    height: 1.5rem;
}



.right_block .txt2 img {
    margin-right: 0.5rem;
}

.alertdialog .block .right_c {

    padding: 1rem;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;

}

.closer_img {
    width: 2.5rem;
    height: 2.5rem;
    object-fit: cover;
    margin-top: 2rem;
    margin-right: 4rem;
}

.main_block {
    margin-bottom: 0 !important;



}

.right_block .txt1 img {

    margin-bottom: -0.3rem;
}

@media screen and (max-width: 750px) {
    .flex_pc {
        display: none !important;
    }

    .flex_mobile {
        display: flex;
    }

    .main_block {
        padding: 0;
        margin: 0;
        overflow-y: auto;
        max-height: 90vh;
       
    }

    .alertdialog .block .left_c {

        padding: 1rem;



    }

    .closer_img {
        width: 2.5rem;
        height: 2.5rem;
        object-fit: cover;
        margin-top: 0rem;
        margin-right: 0.5rem;

    }

    .alertdialog {

        width: 90%;
        /*  height: 80vh;
 
    overflow: auto; 
    box-sizing: border-box; */
    }



    .alertdialog>.block>.r {
        flex-direction: column;
    }

    .alertdialog>.block>.r>.left_c,
    .alertdialog>.block>.r>.right_c {
        width: 100%;
    }

    :deep(.logo1)
    {
        height:3.5rem!important;
    }
    .right_block .txt1 {

        width: 57%;
        display: block;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        font-size: 1.1rem;
        margin-right: 0.2rem;
    }
    :deep(.title1)
    {
        font-size:0.95rem!important;
    }

    .right_block .txt2 {
        width: 43%;
        font-weight:normal;
    }

    .right_block {
        width: 100%;
        border: 1px solid #cccccc;

        margin: 1rem 1rem;
        padding: 1rem 1.0rem;
      
    }

    .right_block .txt2 img {
        width: 1.3rem;
        height: 1.3rem;
        margin-right: 0.2rem;
    }

    .l_line1 {
        margin-top: 4rem;
        margin-left:1.5rem;
        margin-right:1.5rem;

        font-size: 2.0rem;
        line-height: 2.3rem;

    }

    .l_line2 {
        margin-top: 1rem;
        margin-left: 2rem;



        font-size: 1.6rem;


    }

    .l_line3 {
        margin-top: 1rem;
             margin-left:1.5rem;
        margin-right:1.5rem;



        font-size: 1.4rem;


        margin-bottom: 1rem;
        line-height: 1.9rem;
    }


    .h {
        font-size: 2rem !important;
    }

    .alertdialog .picture {
        margin: 30px auto;
    }

    .alertdialog .childcenter {
        font-family: Poppins;
        font-size: 1.2rem;
        font-weight: 700;
        line-height: 2rem;

    }

    .alertdialog .content {
        font-family: Poppins;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 2rem;
        margin-top: 12px;
    }


    .alertdialog .btn .btn-box {

        margin: 15px 0px;
    }

    .alertdialog .btn .button {

        font-size: 1.5rem;

        min-height: 3.2rem;
        width: 90%;

    }

}
</style>